import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CUSTOM_ADJUSTMENTS_ACTION_TYPE } from '../actions';

const initialState = {};

const customAdjustmentsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case CUSTOM_ADJUSTMENTS_ACTION_TYPE.GET_CUSTOM_ADJUSTMENTS:
        return payload || initialState;

      case CUSTOM_ADJUSTMENTS_ACTION_TYPE.CREATE_CUSTOM_ADJUSTMENT:
      case CUSTOM_ADJUSTMENTS_ACTION_TYPE.EDIT_CUSTOM_ADJUSTMENT:
        draft[payload.customAdjustmentTypeId] = payload;
        break;

      case CUSTOM_ADJUSTMENTS_ACTION_TYPE.DELETE_CUSTOM_ADJUSTMENT:
        draft[meta.customAdjustmentTypeId] = {
          ...draft[meta.customAdjustmentTypeId],
          isDeleted: true,
        };
        break;

      case CUSTOM_ADJUSTMENTS_ACTION_TYPE.ENABLE_CUSTOM_ADJUSTMENT:
        draft[meta.customAdjustmentTypeId] = {
          ...draft[meta.customAdjustmentTypeId],
          isDeleted: false,
        };
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default customAdjustmentsReducer;
